const binding = { modules: {}, dataActions: {} };

    (binding.modules['hobart-onboarding-form'] = {
        c: () => require('partner/modules/hobart-onboarding-form/hobart-onboarding-form.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hobart-onboarding-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hobart-onboarding-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hobart-onboarding-form|hobart-onboarding-form'] = {
                c: () => require('partner/modules/hobart-onboarding-form/hobart-onboarding-form.view.tsx'),
                cn: '__local__-__local__-hobart-onboarding-form'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };